import React, {Component} from 'react'
import {DPart, Node} from "../../store/model";
import {getInitialSelectedPapers, getRelatedPapersAndEdgesByNodes, updateSelectNodesState} from "../../utils";
import {SetSelectedEdgesAction, SetSelectedPapersAction, SetSelectedNodesAction} from "../../store/actions";
import names from "../../data/bigName";
import {nodeNameSize, typeNameSize} from './size'

interface props {
    state: any;
    scale: number;
    setSelectedEdges: (newState: Array<number>) => SetSelectedEdgesAction;
    setSelectedPapers: (newState: Array<number>) => SetSelectedPapersAction;
    setSelectedNodes: (newState: Array<number>) => SetSelectedNodesAction;
}

class Nodes extends Component<props> {
    componentDidMount() {}

    render() {
        const {scale} = this.props;
        const size = Math.floor(100 * scale);
        const needR = [2, 3, 4]
        const Division: DPart[] = this.props.state.Division;
        const Nodes: Node[] = this.props.state.NodesData.Nodes;
        const selectedNodes: number[] = this.props.state.NodesData.SelectedNodes;
        const handleMouseOver = (id: number) => {
            if (this.props.state.NodesData.SelectedNodes.length === 0) {
                const {edges, papers} = getRelatedPapersAndEdgesByNodes([id]);
                this.props.setSelectedEdges(edges);
                this.props.setSelectedPapers(papers)
            }
        }
        const handleClick = (id: number) => {
            this.props.setSelectedNodes(updateSelectNodesState(id));
            const {edges, papers} = getRelatedPapersAndEdgesByNodes(this.props.state.NodesData.SelectedNodes);
            if (this.props.state.NodesData.SelectedNodes.length > 0)
                this.props.setSelectedEdges(edges);
            else
                this.props.setSelectedEdges([]);
            this.props.setSelectedPapers(papers);
        }

        const handleMouseOut = (id: number) => {
            if (this.props.state.NodesData.SelectedNodes.length === 0) {
                this.props.setSelectedEdges([]);
                this.props.setSelectedPapers(getInitialSelectedPapers());
            }
        };

        return (
            <>
                {Nodes.map((d: Node, index: number) => (
                    <circle
                        id={"node" + index}
                        key={index}
                        cx={d.cx}
                        cy={d.cy}
                        r={d.r}
                        stroke={Division[d.type - 1].color}
                        strokeWidth={5 * scale + "px"}
                        fill={selectedNodes.includes(d.id) ? Division[d.type - 1].color : 'white'}
                        onMouseOver={function (e) {
                            handleMouseOver(d.id)
                        }}
                        onMouseOut={function (e) {
                            handleMouseOut(d.id)
                        }}
                        onClick={function (e) {
                            handleClick(d.id)
                        }}
                    />
                ))}
                {Nodes.map((d: Node, index: number) => (
                    <rect
                        id={"occlude" + index}
                        key={index}
                        x={d.cx + d.r + 4 * scale}
                        y={d.cy + d.r * 0.2 - 12 * scale}
                        rx={5 * scale}
                        ry={5 * scale}
                        width={nodeNameSize[index][size] * 0.92}
                        height={22 * scale}
                        stroke='2'
                        fill='white'
                        fillOpacity={d.id > Division[3].bIndex ? '0' : '0.8'}
                        pointerEvents="none"
                    />
                ))}
                {Nodes.map((d: Node, index: number) => (
                    <text
                        id={"nodeName" + index}
                        key={index}
                        className="NunitoText"
                        style={
                            {
                                fontSize: 13 * scale * 1.5,
                            }
                        }
                        x={d.cx + d.r * 1.1 + 5 * scale}
                        y={d.cy + d.r * 0.2 + 3 * scale}
                        r={d.r}
                        color={Division[d.type - 1].color}
                        fill={Division[d.type - 1].color}
                        pointerEvents="none"
                    >{d.name}
                    </text>
                ))}
                {names.map((d, index: number) => (
                    <text
                        id={"typeName" + d.id}
                        key={index}
                        className="NunitoText"
                        style={
                            {
                                fontSize: 20 * scale * 1.5,
                            }
                        }
                        x={
                            needR.includes(index) ?
                                Nodes[d.id - 1].cx - 1.2 * typeNameSize[index][size] :
                                Nodes[d.id - 1].cx - 30 * scale}
                        y={
                            needR.includes(index) ?
                                Nodes[d.id - 1].center :
                                Nodes[d.id - 1].center + 0.8 * typeNameSize[index][size] / 2}
                        color={Division[Nodes[d.id - 1].type - 1].color}
                        fill={Division[Nodes[d.id - 1].type - 1].color}
                        transform={
                            needR.includes(index) ?
                                "rotate(315," + (Nodes[d.id - 1].cx) + "," + (Nodes[d.id - 1].center) + ")" :
                                "rotate(270," + (Nodes[d.id - 1].cx - 30 * scale) + "," + (Nodes[d.id - 1].center + typeNameSize[index][size] / 2) + ")"
                        }
                    >{d.name}</text>
                ))}
            </>
        )
    }
}

export default Nodes;